import styled from "styled-components";



export const RedText = styled.span`
    color: var(--danger-color);
`
export const GreenText = styled.span`
    color: var(--success-color);
`
export const AmountLabel = styled.span`
    ${({ $bold }) => $bold && `font-weight: bold;`}
    ${({ $color }) => $color && $color === "success" && `color: var(--success-color);`}
    ${({ $color }) => $color && $color === "danger" && `color: var(--danger-color);`}
    ${({ $color }) => $color && $color === "warning" && `color: var(--warning-color);`}
    ${({ $color }) => $color && $color === "primary" && `color: var(--primary-color);`}
    
`